import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { Context } from '@nuxt/types'
import { Storage } from '@ustra/nuxt/src/vue/store/decorators'
import { CombinedContext } from '@ustra/nuxt/src/vue/store'
import { sessionStorage } from '@ustra/core/src/utils/storage/session-storage'
import { localStorage } from '@ustra/core/src/utils/storage/local-storage'
import { Menu, MenuTree, findMenuById, findMenuByUrl } from '../../models/menu/menu-model'
import { MyMenu } from '../../models/menu/my-menu-model'
import * as storageKey from './storage-key'
import { times } from 'lodash'

export interface MenuDataState {
  _context: Context
  myMenus: MyMenu[]
  rawMenus: Menu[]
  menus: MenuTree[]
  recentMenus: Menu[]
  currentMenu: Menu
  beqmtMenus: MenuTree[]
}

@Module({
  name: 'menuData',
  namespaced: true,
  stateFactory: true,
})
export class MenuDataModule extends VuexModule implements MenuDataState {
  _context: Context = null

  /**
   * 마이 메뉴 목록
   */
  myMenus: MyMenu[] = []

  /**
   * Raw 메뉴 목록
   */
  rawMenus: Menu[] = []

  /**
   * 메뉴 목록
   */
  menus: MenuTree[] = []
  beqmtMenus: MenuTree[] = []

  /**
   * 최근 메뉴 목록
   */
  recentMenus: Menu[] = []

  /**
   * 현재 프로그램 메뉴
   */
  currentMenu: Menu = null

  /**
   * 마이 메뉴 추가
   * @param menu
   */
  @Mutation
  addMyMenu(menu: Menu) {
    const myMenu: MyMenu = {
      menuId: menu.menuId,
      myMenuNm: menu.menuNm,
      prgUrl: menu.prgUrl,
    }

    this.myMenus.push(myMenu)
    sessionStorage.setItem(storageKey.MY_MENU, this.myMenus)
  }

  /**
   * 마이 메뉴 삭제
   * @param menuId
   */
  @Mutation
  removeMyMenu(menuId: string) {
    this.myMenus = this.myMenus.filter((my) => my.menuId !== menuId)
    sessionStorage.setItem(storageKey.MY_MENU, this.myMenus)
  }

  /**
   * 마이 메뉴 셋업
   * @param myMenus
   */
  @Mutation
  @Storage({ type: 'session', propertyKey: storageKey.MY_MENU, defaultValue: [] })
  setMyMenus(myMenus: MyMenu[]) {
    this.myMenus = myMenus
    sessionStorage.setItem(storageKey.MY_MENU, this.myMenus)
  }

  /**
   * 전체 메뉴 셋업
   * @param menus
   */
  @Mutation
  @Storage({ type: 'session', propertyKey: storageKey.RAW_MENU, defaultValue: [] })
  setRawMenus(rawMenus: Menu[]) {
    // @ts-ignore
    this.rawMenus = Object.freeze(rawMenus)
  }

  /**
   * 메뉴 셋업
   * @param menus
   */
  @Mutation
  @Storage({ type: 'session', propertyKey: storageKey.MENU, defaultValue: [] })
  setMenus(menus: Menu[]) {
    const treeMenus: MenuTree[] = []

    for (const menu of menus) {
      const treeMenu: MenuTree = menu
      treeMenu.items = []

      if (!treeMenu.highMenuId) {
        treeMenus.push(treeMenu)
      } else {
        const highMenu = findMenuById(treeMenus, treeMenu.highMenuId)

        if (highMenu) highMenu.items.push(treeMenu)
      }
    }
    // @ts-ignore
    this.menus = Object.freeze(treeMenus).filter((m) => m.menuNm !== '')

    // @ts-ignore
    this.beqmtMenus = Object.freeze(treeMenus).filter((m) => m.menuNm !== '방송자산')
    // this.beqmtMenus = Object.freeze(treeMenus).filter((m) => m.menuNm === '방송자산')
  }

  /**
   * 최근 메뉴 등록
   * @param menuId
   */
  @Mutation
  addRecentMenu(url: string) {
    if (!this.menus) return

    const recentMenu = findMenuByUrl(this.menus, url)

    if (!recentMenu) return

    // 중복제거
    this.recentMenus = this.recentMenus.filter((rm) => rm.menuId !== recentMenu.menuId)

    // 최근 메뉴 추가
    if (!this._context.$ustra.hs.store.auth.currentUser.userId) return

    recentMenu.userId = this._context.$ustra.hs.store.auth.currentUser.userId
    this.recentMenus.unshift(recentMenu)

    // 최근 메뉴 갯수 제한
    this.recentMenus.splice(20)
    localStorage.setItem(storageKey.RECENT_MENU, this.recentMenus)
  }

  /**
   * 최근 메뉴 셋업
   * @param recentMenus
   */
  @Mutation
  @Storage({ type: 'local', propertyKey: storageKey.RECENT_MENU, defaultValue: [] })
  setRecentMenus(recentMenus: Menu[]) {
    console.log('recentMenus::', recentMenus)
    if (recentMenus == null) {
      return []
    }
    this.recentMenus = recentMenus.filter((m) => m.userId === this._context.$ustra.hs.store.auth.currentUser.userId)
  }

  /**
   * 현재 메뉴 정보
   * @param url
   */
  @Mutation
  setCurrentProgramMenu(url: string) {
    if (this.menus) {
      this.currentMenu = findMenuByUrl(this.menus, url)
    } else {
      this.currentMenu = null
    }
  }

  @Mutation
  setContext(context: Context) {
    this._context = context
  }

  @Action
  nuxtServerInit(_arg: CombinedContext) {}

  @Action
  nuxtClientInit(_arg: CombinedContext) {
    this.setContext(_arg.context)
  }
}
